import { render, staticRenderFns } from "./EmployeeConcernHistoryModal.vue?vue&type=template&id=338d924c&scoped=true"
import script from "./EmployeeConcernHistoryModal.vue?vue&type=script&lang=js"
export * from "./EmployeeConcernHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./EmployeeConcernHistoryModal.vue?vue&type=style&index=0&id=338d924c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338d924c",
  null
  
)

export default component.exports